import * as actionType from "../constants";

export const checkLinkForSideMenu = (inputs) => (dispatch) => {
  dispatch({ type: actionType.LINK_STATUS_CHECK, payload: inputs });
  dispatch({ type: actionType.LINK_STATUS_CHECK_CATEGORY });
};
